var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProjectGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-project-18x18",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46657911,2 C5.99054872,2 6.48851104,2.23676928 6.83045113,2.64848882 L9.00252686,5.26381836 L18,5.26381836 L18,14.1333333 C18,15.1642649 17.1941125,16 16.2,16 L1.8,16 C0.80588745,16 0,15.1642649 0,14.1333333 L0,3.86666667 C0,2.83573513 0.80588745,2 1.8,2 L5.46657911,2 Z M5.46657911,3.4 L1.8,3.4 C1.55147186,3.4 1.35,3.60893378 1.35,3.86666667 L1.35,14.1333333 C1.35,14.3910662 1.55147186,14.6 1.8,14.6 L16.2,14.6 C16.4485281,14.6 16.65,14.3910662 16.65,14.1333333 L16.65,6.66381836 L8.3835586,6.66381836 L5.80754711,3.56212221 C5.72206209,3.45919232 5.59757151,3.4 5.46657911,3.4 Z M14.7500747,3 L16,4 L9.24992525,4 L8,3 L14.7500747,3 Z",
    id: "Combined-Shape",
    fill: "#A9B5BE",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectGray);
export default __webpack_public_path__ + "static/media/icon-project-gray.2662167343923507d27501d9aa530c8c.svg";
export { ForwardRef as ReactComponent };